import Header from "./componement/Header";
import Main from "./componement/Main";
import Profile from "./componement/Profile";
import Competance from "./componement/Competance";
import Journey from "./componement/Journey";
import Contact from "./componement/Contact";
import Footer from "./componement/Footer";




function App() {
  return (
    <>
      <Header />
      <Main />
      <Profile />
      <Competance />
      <Journey />
      <Contact />
      <Footer />
    </>
  );
}


export default App ; 